export default __webpack_public_path__ + "static/media/coke-header.25a606e7.png";